/**
 * Initial-load skeleton card for product grids. Mirrors the dimensions of the
 * real product card so the layout doesn't jump when the data lands. Used on
 * the marketplace screen and the per-dispensary menu screen.
 */
export function ProductCardSkeleton() {
  return (
    <li className="flex flex-col overflow-hidden rounded-2xl border border-[var(--card-border)] bg-white shadow-cardMd">
      <div className="aspect-[4/3] animate-pulse bg-[var(--skeleton-bg)]" />
      <div className="space-y-3 p-4">
        <div className="h-3 w-3/4 animate-pulse rounded bg-[var(--skeleton-bg)]" />
        <div className="h-3 w-1/2 animate-pulse rounded bg-[var(--skeleton-bg)]" />
        <div className="h-8 animate-pulse rounded bg-[var(--skeleton-bg)]" />
      </div>
    </li>
  );
}
